import React from 'react';
import './styles.css';

const Filters = ({ option, value, onOptionChange, onValueChange }) => (
  <div className="filters-container">
    <div className="filters-column">
      <label className="filters-label">
        Filtrar por
      </label>
      <select name="option" className="filters-options" value={option} onChange={onOptionChange}>
        <option value="fullName">Nombre</option>
        <option value="specialties">Especialidad</option>
      </select>
    </div>
    <div className="filters-column">
      {option === 'specialties' && [
        <label key="label" name="value" className="filters-label">
          Seleccione una Especialidad
        </label>,
        <select label="value" name="value" className="filters-options" value={value} onChange={onValueChange}>
          <option value="">Todos</option>
          <option value="general">General</option>
          <option value="cirugia">Cirugía</option>
          <option value="endodoncia">Endodoncia</option>
          <option value="implantes">Implantes</option>
          <option value="radiologia">Radiología</option>
          <option value="ortopedia">Ortopedia</option>
          <option value="ortodoncia">Ortodoncia</option>
          <option value="odontopediatria">Odontopediatría</option>
          <option value="periodoncia">Periodoncia</option>
          <option value="odontogeriatría">Odontogeriatría</option>
          <option value="laserterapia">Laserterapia</option>
        </select>
      ]}
      {option === 'fullName' && [
        <label key="label" name="value" className="filters-label">
          Ingrese Nombre
        </label>,
        <input label="value" name="value" className="filters-input" onChange={onValueChange} value={value} />
      ]}
    </div>
  </div>
);

export default Filters;
